export default "__VITE_ASSET__CctZiknr__"